import {ConsumerSubscriptionPlan, SubscriptionPlanContext} from '@udemy/subscription-graphql';

import {useCouponCodeParam} from 'src/hooks/useCouponCodeParam';

/**
 * Suppresses CMS campaign copy when a URL coupon resolved to a plan discount.
 * The discount ribbon and pricing already reflect the coupon so campaign title/subtitle would conflict.
 */
export function useSuppressPersonalPlanCampaignNotice(
    plan?: SubscriptionPlanContext<ConsumerSubscriptionPlan>,
): boolean {
    const couponCode = useCouponCodeParam();
    const subscriptionPlan = plan && 'id' in plan ? plan : undefined;

    return Boolean(couponCode && subscriptionPlan?.selectedDiscount);
}
